module.exports = __webpack_public_path__ + "img/service_mobile_1_2x.156c8148.jpg";